import React from "react"

import { connect } from "react-redux"

import * as actions from '../../../actions'

import ScenarioService from '../../../service/sfp/scenario-service'

import AdminComponent from "./admin-component"

import TableDefinition from "./table-definition"

import Operations from "../common/operations"

import { sortServices } from "../../../domain/sfp/service-domain"

import { getTotalInterestByYear } from "../../../domain/sfp/loan-domain"

import { getProfile, Profile } from "../../../domain/sfp/user-domain";

import _ from "lodash"

class AdminContainer extends React.Component {

    state = {
        currentTab: "revenues",
        shownChapters: [],
        is_gest: false,
        adminId: null,
        revenues: [],
        spending: [],
        revenuesTableDef: [],
        spendingTableDef: [],
        hideRows: false

    }

    componentWillMount() {
        if (!this.props.me.consultedLocalAuthority && !this.props.me.managedLocalAuthority && this.props.me.roles.indexOf("ROLE_ADMIN") == -1 && this.props.me.roles.indexOf("ROLE_SUPER_ADMIN") == -1) {
            if (this.props.me.roles.length > 0 && this.props.me.userType !== 'SERVICE') {
                this.setState({ is_gest: true, adminId: this.props.me.id })
            }
        }
    }

    onHideRows = () => {
        let hideRows = !this.state.hideRows
        this.setState({ hideRows });
    }

    render() {
        if (this.props.scenario) {
            const isServiceAgent = getProfile(this.props.me) === Profile.ServiceAgent
            return (
                <AdminComponent
                    scenario={this.props.scenario}
                    tableDefinition={this._getTableDefinition()}
                    headers={this._getHeaders()}
                    head={this._gethead()}
                    data={this._getData()}
                    localAuthority={this.props.localAuthority}
                    revenues={this.state.revenues}
                    spending={this.state.spending}
                    currentUser={this.props.me}
                    revenuesTableDef={this.state.revenuesTableDef}
                    spendingTableDef={this.state.spendingTableDef}
                    isSuperAdmin={!this.state.is_gest/*(this.props.me.managedLocalAuthority && !this.props.me.consultedLocalAuthority) || (this.props.me.roles.indexOf("ROLE_ADMIN") !== -1 && this.props.me.roles.indexOf("ROLE_SUPER_ADMIN") !== -1)*/}
                    isGest={this.state.is_gest}
                    isAdmin={this.state.adminId !== null}
                    currentTab={this.state.currentTab}
                    hideRows={this.state.hideRows}
                    isServiceAgent={isServiceAgent}
                    themes={this._getThemes()}
                    onTabChange={this._handleTabChange.bind(this)}
                    onChange={this._handleChange.bind(this)}
                    onMouseDown={this._handleMouseDown.bind(this)}
                    onBack={this.props.onBack}
                    onToggleChapter={this._handleToggleChapter.bind(this)}
                    onToggleAdmin={this._handleToggleAdmin.bind(this)}
                    Excel={() => this.calculateExcelfile()}
                    onHideRows={this.onHideRows}

                />
            )
        } else return null
    }

    _getTableDefinition() {
        const consulted = getProfile(this.props.me) === Profile.LocalAuthorityConsultant
        const isServiceAgent = getProfile(this.props.me) === Profile.ServiceAgent
        return TableDefinition(
            this.props.scenarii,
            this.props.scenario,
            this.props.ppi,
            this.props.localAuthority,
            this.state.currentTab,
            this.state.shownChapters,
            this.state.adminId,
            this._getThemes(),
            consulted,
            isServiceAgent
        )
    }

    _getTableDefinitionExcel(res, shownChapters, check) {
        const consulted = getProfile(this.props.me) === Profile.LocalAuthorityConsultant
        const shown = check == 'Incoming' ? this.state.shownChapters : shownChapters
        return TableDefinition(
            this.props.scenarii,
            this.props.scenario,
            this.props.ppi,
            this.props.localAuthority,
            res,
            shown,
            this.state.adminId,
            this._getThemes(),
            consulted
        )
    }


    calculateExcelfile() {
        ["revenues", "spending"].map(res => {
            if (res == "revenues") {
                const tableDef = this._getTableDefinitionExcel(res, 'Incoming')
                let shownChapters = []
                tableDef.rows.forEach(row => {
                    let chapter = row && row.chapter
                    shownChapters.push(chapter && chapter.id)
                })
                const table = this._getTableDefinitionExcel(res, shownChapters, 'onClick')
                this.setState({ revenues: this._getDataExcel(res, shownChapters), revenuesTableDef: table })
            }
            if (res == "spending") {
                const tableDef = this._getTableDefinitionExcel(res, 'Incoming')
                let shownChapters = []
                tableDef.rows.forEach(row => {
                    let chapter = row && row.chapter
                    shownChapters.push(chapter && chapter.id)
                })
                const table = this._getTableDefinitionExcel(res, shownChapters, 'onClick')
                this.setState({ spending: this._getDataExcel(res, shownChapters), spendingTableDef: table })
            }
        })
    }

    _getOperations() {
        return new Operations(this.props.scenario, this.props.ppi, this.props.localAuthority)
    }

    _getHeaders() {
        var headers = []

        //if (!this.state.adminId) {
        if (getProfile(this.props.me) !== Profile.ServiceAgent)
            headers.push("<div class='global-header'><div><i class='fa fa-building'></i></div><div><span class='global-year'>" + this.props.scenario.year + "</span></div></div>")
        headers.push("<div class='global-header'><div><i class='fa fa-user'></i></div><div><span class='global-year'>" + this.props.scenario.year + "</span></div></div>")
        //headers.push(this.props.scenario.year + " (Scénario)")
        //headers.push(this.props.scenario.year + " (Gestionnaires)")
        //}

        var validator
        this._getThemes().map(theme => {
            validator = this.props.scenario.validated_themes.find(vt => vt.theme_id == theme.id)
            headers.push("<div class='theme-header" + (validator && validator.validated ? " theme-validated" : "") + "'><div><i class='fa fa-check'></i></div><div class='theme-name'><span title='" + (theme.description || theme.label) + "'>" + theme.label + "</span><div><i class='fa fa-chevron-down' style='margin-left: 5px'></i></div> </div></div>")
        })

        return headers
    }

    _gethead() {
        let head = []
        head.push("Artical")
        head.push(this.props.scenario.year)
        head.push(`${this.props.scenario.year}(1)`)
        this._getThemes().map(theme => {
            head.push(theme.label)
        })
        return head
    }

    _getDataExcel(res, shownChapters) {
        var data = []

        var previous_scenario = null
        const totalInterestByYear = Math.round(getTotalInterestByYear(this.props.loans, this.props.scenario.year))
        if (this.props.scenario.year == (new Date()).getFullYear() + 1) {
            var previous_scenarii = this.props.scenarii.find(s => s.year == this.props.scenario.year - 1)
            if (previous_scenarii) {
                previous_scenario = previous_scenarii.scenarii.find(s => s.validated)
            }
        }

        var row, value, totalRow = ["Total"]
        var validator, theme_values
        this._getTableDefinitionExcel(res, shownChapters, 'onClick').rows.map(r => {
            row = []
            row.push(r.title)

            //if (!this.state.adminId) {
            var scenarioSum = 0, adminSum = 0
            if (r.account) {
                this.props.scenario.themes.filter(t => t.account_id == r.account.id && t.receipts == (res == "revenues")).map(t => {
                    adminSum += t.amount
                })
                scenarioSum = this._getOperations().findValue(this.props.scenario.year, r.account.id, r.chapter.id, r.chapter.receipts, previous_scenario)
                if (r.account.number === "66111") scenarioSum = totalInterestByYear
            } else if (r.chapter) {
                this.props.localAuthority.accounts.filter(a => r.chapter.id == (a.chapter ? a.chapter.id : -1)).map(a => {
                    this.props.scenario.themes.filter(t => t.account_id == a.account.id && t.receipts == (res == "revenues")).map(t => {
                        adminSum += t.amount
                    })
                })
                r.chapter.accounts.map(account => {
                    scenarioSum += this._getOperations().findValue(this.props.scenario.year, account.id, r.chapter.id, r.chapter.receipts, previous_scenario)
                    if (account.number === "66111") scenarioSum = totalInterestByYear
                })
            }

            row.push(scenarioSum)
            row.push(adminSum)
            if (!this.state.adminId && r.chapter && !r.account) {
                if (totalRow.length == 1) {
                    totalRow.push(scenarioSum)
                } else {
                    totalRow[1] += scenarioSum
                }
                if (totalRow.length == 2) {
                    totalRow.push(adminSum)
                } else {
                    totalRow[2] += adminSum
                }
            }
            //}

            this._getThemes().map((theme, themeIndex) => {
                if (r.chapter || r.account) {
                    theme_values = this.props.scenario.themes.filter(t => t.theme_id == theme.id && t.amount !== null && t.amount !== undefined && t.receipts == (res == "revenues"))
                    validator = this.props.scenario.validated_themes.find(vt => vt.theme_id == theme.id)
                    if (r.account) {
                        value = this.props.scenario.themes.find(t => (t.account_id == r.account.id && t.theme_id == theme.id && t.receipts == (res == "revenues")))
                        value = {
                            amount: value ? Math.round(value.amount) : null,
                            checked: value ? "checked" : "not-checked",
                            theme,
                            theme_validated: validator && validator.validated
                        }
                    } else if (r.chapter) {
                        var accounts = this.props.scenario.themes.filter(t => (t.theme_id == theme.id && (r.accountIds.indexOf(t.account_id) !== -1) && t.receipts == (res == "revenues")))
                        value = 0
                        accounts.map(a => {
                            value += a.amount
                        })
                        value = {
                            amount: Math.round(value),
                            checked: r.accountsLength == accounts.length ? "checked" : (accounts.length > 0 ? "partial" : "not-checked"),
                            theme_validated: validator && validator.validated,
                            theme_has_values: theme_values.filter(tv => (tv.chapter && tv.chapter.id == r.chapter.id) || (!tv.chapter && ((res == "revenues" && r.chapter.id == -1) || (res == "spending" && r.chapter.id == -2)))).length > 0,
                            theme_values
                        }
                    }
                    value.theme = theme
                    if (this.state.adminId) value = value.amount
                    row.push(value)
                }

                if (!this.state.adminId && r.chapter && !r.account) {
                    if (totalRow.length <= themeIndex + 3) {
                        totalRow.push(value.amount)
                    } else {
                        totalRow[themeIndex + 3] += value.amount
                    }
                }

            })

            if (r.account || r.chapter) {
                data.push(row)
            }
        })

        if (!this.state.adminId) {
            data.push(totalRow)
        }

        return data
    }

    _getData() {
        var data = []

        var previous_scenario = null
        const totalInterestByYear = Math.round(getTotalInterestByYear(this.props.loans, this.props.scenario.year))
        if (this.props.scenario.year == (new Date()).getFullYear() + 1) {
            var previous_scenarii = this.props.scenarii.find(s => s.year == this.props.scenario.year - 1)
            if (previous_scenarii) {
                previous_scenario = previous_scenarii.scenarii.find(s => s.validated)
            }
        }

        var row, value, totalRow = ["Total"]
        var validator, theme_values
        this._getTableDefinition().rows.map(r => {
            row = []
            row.push(r.title)

            //if (!this.state.adminId) {
            var scenarioSum = 0, adminSum = 0
            if (r.account) {
                this.props.scenario.themes.filter(t => t.account_id == r.account.id && t.receipts == (this.state.currentTab == "revenues")).map(t => {
                    adminSum += t.amount
                })
                scenarioSum = this._getOperations().findValue(this.props.scenario.year, r.account.id, r.chapter.id, r.chapter.receipts, previous_scenario)
                if (r.account.number === "66111") scenarioSum = totalInterestByYear
            } else if (r.chapter) {
                this.props.localAuthority.accounts.filter(a => r.chapter.id == (a.chapter ? a.chapter.id : -1)).map(a => {
                    this.props.scenario.themes.filter(t => t.account_id == a.account.id && t.receipts == (this.state.currentTab == "revenues")).map(t => {
                        adminSum += t.amount
                    })
                })
                r.chapter.accounts.map(account => {
                    scenarioSum += this._getOperations().findValue(this.props.scenario.year, account.id, r.chapter.id, r.chapter.receipts, previous_scenario)
                    if (account.number === "66111") scenarioSum = totalInterestByYear
                })
            }

            if (getProfile(this.props.me) !== Profile.ServiceAgent)
                row.push(scenarioSum)

            row.push(adminSum)
            if (!this.state.adminId && r.chapter && !r.account) {
                if (getProfile(this.props.me) !== Profile.ServiceAgent) {
                    if (totalRow.length == 1) {
                        totalRow.push(scenarioSum)
                    } else {
                        totalRow[1] += scenarioSum
                    }
                    if (totalRow.length == 2) {
                        totalRow.push(adminSum)
                    } else {
                        totalRow[2] += adminSum
                    }
                } else {
                    if (totalRow.length == 1) {
                        totalRow.push(adminSum)
                    } else {
                        totalRow[1] += adminSum
                    }
                }
            }
            //}

            this._getThemes().map((theme, themeIndex) => {
                if (r.chapter || r.account) {
                    theme_values = this.props.scenario.themes.filter(t => t.theme_id == theme.id && t.amount !== null && t.amount !== undefined && t.receipts == (this.state.currentTab == "revenues"))
                    validator = this.props.scenario.validated_themes.find(vt => vt.theme_id == theme.id)
                    if (r.account) {
                        value = this.props.scenario.themes.find(t => (t.account_id == r.account.id && t.theme_id == theme.id && t.receipts == (this.state.currentTab == "revenues")))
                        value = {
                            amount: value ? Math.round(value.amount) : null,
                            checked: value ? "checked" : "not-checked",
                            theme,
                            theme_validated: validator && validator.validated
                        }
                    } else if (r.chapter) {
                        var accounts = this.props.scenario.themes.filter(t => (t.theme_id == theme.id && (r.accountIds.indexOf(t.account_id) !== -1) && t.receipts == (this.state.currentTab == "revenues")))
                        value = 0
                        accounts.map(a => {
                            value += a.amount
                        })
                        value = {
                            amount: Math.round(value),
                            checked: r.accountsLength == accounts.length ? "checked" : (accounts.length > 0 ? "partial" : "not-checked"),
                            theme_validated: validator && validator.validated,
                            theme_has_values: theme_values.filter(tv => (tv.chapter && tv.chapter.id == r.chapter.id) || (!tv.chapter && ((this.state.currentTab == "revenues" && r.chapter.id == -1) || (this.state.currentTab == "spending" && r.chapter.id == -2)))).length > 0,
                            theme_values
                        }
                    }
                    value.theme = theme
                    if (this.state.adminId) value = value.amount
                    row.push(value)
                }

                if (!this.state.adminId && r.chapter && !r.account) {
                    if (totalRow.length <= themeIndex + 3) {
                        totalRow.push(value.amount)
                    } else {
                        totalRow[themeIndex + 3] += value.amount
                    }
                }

            })

            if (r.account || r.chapter) {
                data.push(row)
            }
        })

        if (!this.state.adminId) {
            data.push(totalRow)
        }

        return data
    }

    _getThemes() {
        var themes = this.props.currentServices
        sortServices(themes)

        if (this.state.adminId && this.state.is_gest) {
            var scenarioThemeIds = this.props.scenario.themes.map(t => t.theme_id)
            //themes = themes.filter(t => (t.responsible.id == this.state.adminId && scenarioThemeIds.indexOf(t.id) !== -1))
            themes = themes.filter(t => (_.get(this.props, "me.services", []).map(s => s.id).indexOf(t.id) !== -1)) //t.referents.map(a => a.id).indexOf(this.state.adminId) !== -1))
        }
        return themes
    }

    _updateScenario(scenario) {
        this.props.onScenarioUpdated(scenario)
    }

    _handleTabChange(type) {
        this.setState({ currentTab: type })
    }

    _handleChange = (type, data, source, hiddenRowsId) => {
        var scenario = this.props.scenario
        switch (type) {
            case "main":
                if (data) {
                    var row, col, value, dummy
                    var account, theme, stheme, index
                    data.map(cell => {
                        [row, col, dummy, value] = cell
                        // Récupération de l'ensemble des lignes du tableau
                        let tableDef = this._getTableDefinition();
                        if (this.state.hideRows && hiddenRowsId && hiddenRowsId.length > 0) {
                            // Suppression des lignes qui ont été masquées
                            for (let i = tableDef.rows.length - 1; i >= 0; i--) {
                                if (hiddenRowsId.includes(i)) {
                                    tableDef.rows.splice(i, 1);
                                }
                            }
                        }
                        account = tableDef.rows[row].account
                        theme = this._getThemes()[col - 3]
                        stheme = scenario.themes.find(t => (t.account_id == account.id && t.theme_id == theme.id && t.receipts == (this.state.currentTab == "revenues")))
                        if (value !== null && value !== undefined && value !== "") {
                            //stheme.amount = Math.round(100 * parseFloat(value)) / 100
                            stheme.amount = Math.round(parseFloat(value))
                        } else {
                            stheme.amount = null
                        }
                        ScenarioService.updateAccountThemeValue(scenario, account, theme, stheme.amount, this.state.currentTab == "revenues")
                            .then(null, this._dispatchReceiveError.bind(this))
                    })
                    this._updateScenario(scenario)
                }
                break
            case "account_theme":
                if (data.account) {
                    if (data.checked) {
                        scenario.themes.push({
                            theme_id: data.theme.id,
                            account_id: data.account.id,
                            receipts: this.state.currentTab == "revenues",
                            amount: null
                        })
                        ScenarioService.updateAccountThemeValue(this.props.scenario, data.account, data.theme, null, this.state.currentTab == "revenues")
                            .then(null, this._dispatchReceiveError.bind(this))
                    } else {
                        var index = scenario.themes.map(t => (t.theme_id + "-" + t.account_id)).indexOf(data.theme.id + "-" + data.account.id)
                        scenario.themes.splice(index, 1)
                        ScenarioService.deleteAccountTheme(this.props.scenario, data.account, data.theme)
                            .then(null, this._dispatchReceiveError.bind(this))
                    }
                } else {
                    var accountIds = []
                    if (data.checked) {
                        data.accountIds.map(accountId => {
                            if (!scenario.themes.find(t => (t.theme_id == data.theme.id && t.account_id == accountId && t.receipts == (this.state.currentTab == "revenues")))) {
                                scenario.themes.push({
                                    theme_id: data.theme.id,
                                    account_id: accountId,
                                    receipts: this.state.currentTab == "revenues",
                                    amount: null
                                })
                                accountIds.push(accountId)
                            }
                        })
                        ScenarioService.updateAccountsThemeValue(this.props.scenario, accountIds, data.theme, null, this.state.currentTab == "revenues")
                            .then(null, this._dispatchReceiveError.bind(this))
                    } else {
                        var index
                        data.accountIds.map(accountId => {
                            var themes = scenario.themes.map(t => (t.theme_id + "-" + t.account_id + "-" + t.receipts))
                            if ((index = themes.indexOf(data.theme.id + "-" + accountId + "-" + (this.state.currentTab == "revenues"))) !== -1) {
                                scenario.themes.splice(index, 1)
                                accountIds.push(accountId)
                            }
                        })
                        ScenarioService.deleteAccountsTheme(this.props.scenario, accountIds, data.theme)
                            .then(null, this._dispatchReceiveError.bind(this))
                    }
                }
                this._updateScenario(scenario)
                break
        }
    }

    _handleMouseDown(coords) {
        if (!this.state.adminId && coords.row == -1) {
            if (coords.col > 2) {
                var theme = this.props.currentServices[coords.col - 3]
                this.props.onCustomAction({ action: "toggle_valid_theme", actionData: { theme } })
            }
        }
    }

    _handleToggleChapter(chapter) {
        let shownChapters = this.state.shownChapters
        var index
        if ((index = shownChapters.indexOf(chapter.id)) !== -1) {
            shownChapters.splice(index, 1)
        } else {
            shownChapters.push(chapter.id)
        }
        this.setState({ shownChapters })
    }

    _handleToggleAdmin() {
        this.setState({ adminId: this.state.adminId ? null : 4 })
    }

    _dispatchReceiveError(error) {
        this.props.actions.throwError(error);
        this.setState({ loading: false });
    }

}

const mapStateToProps = (state) => ({
    me: state.currentUser,
    currentServices: state.currentLocalAuthorityServices
})

export default connect(mapStateToProps)(AdminContainer)



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/admin-container.js